<template>
  <div class="sa-card sa-card-border sa-card-noshadow">
    <avtar
      :editBoolean="editBoolean"
      @editFlag="pflag = $event"
      @imgEvent="imgUrl = $event"
    />
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <div class="sa-tit-heading sa-h-sm-up">Medical Specialities</div>
      <form @submit.prevent>
        <div class="sa-row">
          <div
            v-if="pInfo.personal.utid == '1'"
            class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4"
          >
            <ValidationProvider
              rules="required"
              tag="div"
              class="sa-form-group"
              v-slot="{ errors }"
              name="Speciality"
            >
              <label>Speciality</label>
              <v-select
                disabled
                :options="specialityList"
                v-model="medSpecReq.medical.dept_id"
                label="name"
                name="speciality"
                id="speciality"
                :reduce="(d) => d.id"
                :class="!pflag ? 'sa-disabled' : ''"
                ><span slot="no-options">No data</span></v-select
              >
              <!-- <input v-model="medSpecReq.dept" type="text" class="sa-form-control" :disabled="!pflag" :class="!pflag?'sa-disabled':''"/> -->
              <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div
            v-if="pInfo.personal.utid == '1'"
            class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4"
          >
            <div class="sa-form-group">
              <label>Classification</label>
              <v-select
                :options="classificList"
                v-model="medSpecReq.medical.class_id"
                label="name"
                :reduce="(c) => c.clId"
                id="classification"
                name="classification"
                disabled
                :class="!pflag ? 'sa-disabled' : ''"
                ><span slot="no-options">No data</span></v-select
              >
            </div>
          </div>
          <div
            v-if="pflag"
            class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4"
          >
            <ValidationProvider
              rules="required"
              tag="div"
              class="sa-form-group"
              v-slot="{ errors }"
              name="Experience"
            >
              <label>
                Experience
                <span class="sa-red-text" v-if="pflag">*</span>
              </label>
              <input
                v-model="medSpecReq.medical.exp.val"
                type="number"
                class="sa-form-control"
                :disabled="!pflag"
                :class="!pflag ? 'sa-disabled' : ''"
                id="experience"
                name="experience"
              />
              <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div
            v-if="!pflag"
            class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4"
          >
            <ValidationProvider
              rules="required"
              tag="div"
              class="sa-form-group"
              v-slot="{ errors }"
              name="Experience"
            >
              <label>
                Experience
                <span class="sa-red-text" v-if="pflag">*</span>
              </label>
              <input
                :placeholder="experienceFunc()"
                id="experienceAr"
                name="experienceAr"
                type="number"
                class="sa-form-control"
                :disabled="!pflag"
                :class="!pflag ? 'sa-disabled' : ''"
              />
              <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <!-- <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
            <ValidationProvider rules="required" tag="div" class="sa-form-group" v-slot="{errors}" name="Specialist">
              <label>
                Specialist
                <span class="sa-red-text">*</span>
              </label>
              <v-select
                :options="specTitles"
                v-model="medSpecReq.medical.prof_title"
                label="name"
                :reduce="c => c.id"
                :disabled="!pflag"
                :class="!pflag?'sa-disabled':''"
              ><span slot="no-options">No data</span></v-select>
            <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </div> -->
          <div
            v-if="pInfo.personal.utid == '1'"
            class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4"
          >
            <div class="sa-form-group">
              <label>I Specialized in</label>
              <!-- <input
                            @input="medSpecReq.res = medSpecReq.res.split(',')"
                            v-model="medSpecReq.res"
                            type="text"
                            class="sa-form-control"
                            :disabled="!pflag"
                            :class="!pflag?'sa-disabled':''"
              />-->
              <v-select
                taggable
                class="sa-multiple-tag"
                multiple
                v-model="medSpecReq.medical.special_in"
                :disabled="!pflag"
                :class="!pflag ? 'sa-disabled' : ''"
                name="specialized"
                id="specialized"
                ><span slot="no-options">No data</span></v-select
              >
            </div>
          </div>
          <div
            v-if="pInfo.personal.utid == '1'"
            v-show="pflag"
            class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4"
          >
            <div class="sa-form-group">
              <label>I Specialized in (Arabic)</label>
              <!-- <input
                            @input="medSpecReq.res = medSpecReq.res.split(',')"
                            v-model="medSpecReq.res"
                            type="text"
                            class="sa-form-control"
                            :disabled="!pflag"
                            :class="!pflag?'sa-disabled':''"
              />-->
              <v-select
                taggable
                class="sa-multiple-tag"
                multiple
                v-model="medSpecReq.medical.special_in_ar"
                id="specializedAR"
                :disabled="!pflag"
                :class="!pflag ? 'sa-disabled' : ''"
                name="specializedAR"
                ><span slot="no-options">No data</span></v-select
              >
            </div>
          </div>
          <div
            v-if="pInfo.personal.utid == '1'"
            class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4"
          >
            <div class="sa-form-group">
              <label>Sub Speciality</label>
              <!-- <input
                            @input="medSpecReq.res = medSpecReq.res.split(',')"
                            v-model="medSpecReq.res"
                            type="text"
                            class="sa-form-control"
                            :disabled="!pflag"
                            :class="!pflag?'sa-disabled':''"
              />-->
              <v-select
                :options="subSpecList"
                v-model="medSpecReq.medical.sub_speclty_id"
                label="name"
                :reduce="(c) => c.id"
                name="Sub Speciality"
                id="subSpeciality"
                disabled
                :class="!pflag ? 'sa-disabled' : ''"
                ><span slot="no-options">No data</span></v-select
              >
            </div>
          </div>
          <div
            v-if="pInfo.personal.utid == '1'"
            class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4"
          >
            <div class="sa-form-group">
              <label>Membership</label>
              <v-select
                v-model="medSpecReq.medical.memship"
                taggable
                multiple
                class="sa-multiple-tag"
                :disabled="!pflag"
                :class="!pflag ? 'sa-disabled' : ''"
                name="membership"
                id="membership"
                ><span slot="no-options">No data</span></v-select
              >
            </div>
          </div>
          <div
            v-if="pflag && pInfo.personal.utid == '1'"
            class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4"
          >
            <div class="sa-form-group">
              <label>Membership in (Arabic)</label>
              <v-select
                v-model="medSpecReq.medical.memship_ar"
                taggable
                multiple
                class="sa-multiple-tag"
                :disabled="!pflag"
                :class="!pflag ? 'sa-disabled' : ''"
                id="membershipAr"
                name="membershipAr"
                ><span slot="no-options">No data</span></v-select
              >
            </div>
          </div>
          <!-- <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
                        <div class="sa-form-group">
                            <label>Professional Title</label>
                            <v-select :options="specTitles" v-model="medSpecReq.prof_title" label="name"
                                :reduce="c => c.id" :disabled="!pflag" :class="!pflag?'sa-disabled':''"></v-select>
                        </div>
          </div> -->
          <!-- <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
                        <div class="sa-form-group">
                            <ValidationProvider name="experience" rules="required|decimal|min_value:4" v-slot="{ errors }" tag="div"
                                class="sa-form-group">
                                <label>Experience (Years) <span class="sa-red-text">*</span></label>
                                <input v-model="medSpecReq.exp.val" type="text" class="sa-form-control"
                                    :disabled="!pflag" :class="!pflag?'sa-disabled':''" />
                                <span class="sa-val-err">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
          </div>-->

          <!-- <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
            <div class="sa-form-group">
              <label>Designation</label>
              <input
                v-model="medSpecReq.medical.des"
                type="text"
                class="sa-form-control"
                :disabled="!pflag"
                :class="!pflag?'sa-disabled':''"
              />
            </div>
          </div> -->
          <!-- <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
                        <div class="sa-form-group">
                            <label>Department</label>
                            <v-select :options="subSpecList" v-model="medSpecReq.sub_speclty_id" label="name"
                                :reduce="c => c.id" :disabled="!pflag" :class="!pflag?'sa-disabled':''"></v-select>
                        </div>
          </div>-->
          <!-- <div class="sa-row">
          <div class="sa-col-xs12 sa-col-sm6 sa-col-md8 sa-col-lg8">
            <div class="sa-form-group">
              <label>Attachment</label>
              <div class="sa-row">
                <div
                  class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6"
                  :disabled="!pflag"
                  :class="!pflag?'sa-disabled':''"
                >
                  <file-upload v-on:file-upload-success="setImg($event, 'certs')" />
                </div>
                <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6">
                  <div class="sa-f-up-doc sa-mt10">
                    <a :href="img" target="_blank" class="sa-f-up-info" v-if="isImage(icon_bio)">
                      <img :src="img" alt />
                    </a>
                    <a :href="img" target="_blank" class="sa-f-up-info" v-else>
                      <i :class="attachBioIcons"></i>
                    </a>
                    <a class="sa-f-up-name sa-ellipsis" v-if="imgName">{{ imgName }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

          <!-- <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
            <ValidationProvider rules="required" tag="div" class="sa-form-group" v-slot="{errors}" name="Experience in Arabic">
              <label>
                Experience in years (Arabic)
                <span class="sa-red-text">*</span>
              </label>
              <input
                v-model="medSpecReq.medical.exp.ar.val"
                type="text"
                class="sa-form-control"
                :disabled="!pflag"
                :class="!pflag?'sa-disabled':''"
              />
            <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </div> -->
          <!-- <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg8">
          <div class="sa-form-group">
            <label>Specialist</label>
            <span :disabled="!pflag" :class="!pflag?'sa-disabled sa-d-none ':'sa-p-checkbox '">
              <input type="checkbox" id="checkbox" v-model="medSpecReq.medical.specialist" />
              <label for="checkbox">Is Specialist</label>
            </span>
            <span v-if="medSpecReq.medical.specialist" :disabled="!pflag" :class="!pflag?'':'sa-d-none'">
              <span class="sa-status-active sa-mr10"></span>
              <span class="sa-green-text">Yes</span>
            </span>
            <span v-if="!medSpecReq.medical.specialist" :disabled="!pflag" :class="!pflag?'':'sa-d-none'">
              <span class="sa-status-inactive sa-mr10"></span>
              <span class="sa-red-text">No</span>
            </span>
          </div>
        </div> -->
          <!-- <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
                    <div class="sa-form-group">
                        <label>Clinical Experince</label>
                        <input v-model="medSpecReq.cli_exp" type="text" class="sa-form-control" :disabled="!pflag" :class="!pflag?'sa-disabled':''"/>
                    </div>
          </div>-->
          <!-- <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
                    <div class="sa-form-group">
                        <label>Degree</label>
                            <select v-model="medSpecReq.deg" class="sa-form-control" :disabled="!pflag" :class="!pflag?'sa-disabled':''">
                            <option></option></select> =
                        <v-select :options="selectspeciality" class="sa-multiple-tag" taggable multiple push-tags v-model="medSpecReq.deg" :disabled="!pflag" :class="!pflag?'sa-disabled':''"></v-select>
                    </div>
          </div>-->
          <!-- <div class="sa-col-xs12 sa-col-sm6 sa-col-md8 sa-col-lg8">
                    <div class="sa-form-group">
                        <label>Attach Bio Attachment</label>
                        <div class="sa-row">
                            <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6" :disabled="!pflag" :class="!pflag?'sa-disabled':''">
                                <file-upload v-on:file-upload-success="setImg($event, 'certs')"/>
                            </div> 
                            <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6">
                                <div class="sa-f-up-doc sa-mt10">
                                    <a :href="img" target="_blank" class="sa-f-up-info" v-if="isImage(icon_bio)"><img :src="img" alt=""></a>
                                    <a :href="img" download class="sa-f-up-info" v-else>
                                        <i :class="attachBioIcons"></i>
                                    </a>
                                    <a class="sa-f-up-name sa-ellipsis" v-if="imgName">{{ imgName }}</a>
                                </div>
                            </div> 
                        </div>
                    </div>
                </div>
                <div class="sa-col-xs12 sa-col-sm12 sa-col-md12 sa-col-lg12">
                    <div class="sa-form-group">
                        <label>Short Biography</label>
                        <textarea v-model="medSpecReq.bio" class="sa-form-control" :disabled="!pflag" :class="!pflag?'sa-disabled':''"/>
                    </div>
          </div>-->
        </div>

        <div v-if="pflag" class="sa-text-right">
          <button
            class="sa-btn sa-btn-primary sa-btn-block-xs"
            @click.prevent="handleSubmit(updateProfile)"
          >
            Save
          </button>
        </div>
      </form>
      <div class="sa-dialog-white" v-if="loader">
        <img src="../../assets/img/loader.svg" alt="loader" class="sa-loader" />
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import AvtarVue from "../common/Avtar.vue";
import FileUploadVue from "../common/FileUpload.vue";
import { pro_url } from "../../../config/endpoints";
import { oh_url, com_url } from "../../../config/endpoints";
import { extend } from "vee-validate";
import { required, min_value } from "vee-validate/dist/rules";

extend("required", {
  ...required,
  message: `Please provide {_field_}`,
});
extend("min_value", {
  ...min_value,
  message: "The {_field_} cannot be a negative value",
});
extend("decimal", {
  validate: (value, { decimals = "*", separator = "." } = {}) => {
    if (value === null || value === undefined || value === "") {
      return {
        valid: false,
      };
    }
    if (Number(decimals) === 0) {
      return {
        valid: /^-?\d*$/.test(value),
      };
    }
    const regexPart = decimals === "*" ? "+" : `{1,${decimals}}`;
    const regex = new RegExp(
      `^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`
    );

    return {
      valid: regex.test(value),
    };
  },
  message: "The {_field_} field must contain only valid number",
});

export default {
  props: ["pInfo"],
  components: {
    "file-upload": FileUploadVue,
    avtar: AvtarVue,
  },
  data() {
    return {
      imgUrl: null,
      imageFormat: [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "bmp",
        "tif",
        "tiff",
        "eps",
        "raw",
        "cr2",
        "nef",
        "orf",
        "sr2",
        "PSD",
        "XCF",
        "AI",
        "CDR",
        "jfif",
      ],
      icon_bio: null,
      editBoolean: false,
      loader: false,
      pflag: false,
      img: "",
      imgName: "",
      dept: "",
      selectspeciality: [],
      classificList: [],
      specialityList: [],
      subSpecList: [],
      specTitles: [],
      profTitles: [],
      medSpecReq: {
        mtype: "medical",
        medical: {
          img: "",
          des: "Junior", //designation
          sub_speclty_id: "MSS63",
          prof_title: "PRT2", // specialist
          exp: {},
          class_id: "",
          special_in: [],
          special_in_ar: [],
          dept_id: "DP7", // speciality
          med_reg: "91MED",
          memship: [],
          memship_ar: [],
          med_reg_att: {
            file_nm: "img.jpg",
            url:
              "https://img.litedev.com/mis/a6a7a6ac8bf17abe2988d088d16102e7.jpg",
          },
        },
      },
    };
  },
  computed: {
    attachBioIcons() {
      return "icon-" + this.icon_bio;
    },
  },
  methods: {
    experienceFunc() {
      return this.medSpecReq.medical.exp.val + " years";
    },
    isImage(fileType) {
      if (this.imageFormat.includes(fileType)) {
        return true;
      }
      return false;
    },
    setImg(uimg) {
      let _self = this;
      _self.img = uimg;
      _self.imgName = uimg.filename;
      _self.icon_bio = uimg.filename.split(".")[1] || null;
      _self.medSpecReq.medical.med_reg_att = {
        file_nm: uimg.filename,
        url: uimg.url,
      };
    },
    setProfileData() {
      let _self = this;
      _self.medSpecReq.medical = _self.pInfo.medical;
      // if (!_self.medSpecReq.medical.exp) {
      //   _self.medSpecReq.medical.exp = {
      //     en: {
      //       val: "",
      //       dur_typ: "Years",
      //     },
      //     ar: {
      //       val: "",
      //       dur_typ: "سنوات",
      //     },
      //   };
      // }
      // if (!_self.medSpecReq.medical.exp.ar) {
      //   _self.medSpecReq.medical.exp.ar = {
      //     val: "",
      //     dur_typ: "سنوات",
      //   };
      // }
      // if (!_self.medSpecReq.medical.exp.en) {
      //   _self.medSpecReq.medical.exp.en = {
      //     val: "",
      //     dur_typ: "Years",
      //   };
      // }
      if (_self.medSpecReq.medical.med_reg_att) {
        _self.img = _self.medSpecReq.medical.med_reg_att.url;
        _self.imgName = _self.medSpecReq.medical.med_reg_att.file_nm;
        _self.icon_bio = _self.imgName.split(".")[1] || null;
      }
      // _self.medSpecReq['prof_title'] = _self.pInfo.prof_title
      // _self.medSpecReq['exp']['val'] = _self.pInfo.exp && _self.pInfo.exp.val ? _self.pInfo.exp.val : "";
      // _self.medSpecReq['class_id'] = _self.pInfo.class_id
      // _self.medSpecReq['sub_speclty_id'] = _self.pInfo.sub_speclty_id
      // _self.medSpecReq['special_in'] = _self.pInfo.special_in
      // _self.medSpecReq['res'] = _self.pInfo.res
      // _self.medSpecReq['cli_exp'] = _self.pInfo.cli_exp
      // _self.medSpecReq['bio'] = _self.pInfo.bio
      // _self.medSpecReq['bio_att'] = _self.pInfo.bio_att
      // _self.dept = _self.pInfo.dept_id
      // _self.img = _self.pInfo.bio_att[0].url
      // _self.imgName = _self.pInfo.bio_att[0].name
      // _self.icon_bio = _self.pInfo.bio_att[0].name.split(".")[1] || null;
    },
    // get static data
    getStaticData() {
      let _self = this;
      _self.$store
        .dispatch("httpPost", {
          uri: `${oh_url}/general/getStaticData`,
          body: {
            mtype: ["classifications", "subSpec", "title", "nameTitles"],
            utid: "1",
          },
        })
        .then((response) => {
          if ((response.status = 1000)) {
            _self.classificList = response.data.classifications;
            _self.profTitles = response.data.nameTitles;
            _self.nationalityList = response.data.country;
            _self.subSpecList = response.data.subSpeciality;
            _self.specTitles = response.data.titles;
          }
        })
        .catch((e) => {});
    },
    // get list of departments for sanar doctor resgistration
    getDeptList() {
      let _self = this;
      _self.$store
        .dispatch("httpGet", {
          uri: `${pro_url}/getDepartments`,
        })
        .then((response) => {
          if ((response.status = 1000)) {
            _self.specialityList = response.depts;
          }
        })
        .catch((e) => {});
    },
    updateProfile(obj, params) {
      let _self = this;
      _self.loader = true;
      if (_self.imgUrl) {
        _self.medSpecReq.medical.img = _self.imgUrl;
        let userInfo = JSON.parse(_self.$localStorage.get("userdata")) || {};
        userInfo.img = _self.imgUrl;
        _self.$localStorage.set(
          "userdata",
          JSON.stringify(userInfo),
          60 * 60 * 2 + 55
        );
      }
      if (!_self.medSpecReq.medical.sub_speclty_id) {
        _self.medSpecReq.medical.sub_speclty_id = "";
      }
      //   _self.medSpecReq.special_in = _self.medSpecReq.special_in.filter(
      //     (e) => e.trim() != ""
      //   );
      //   _self.medSpecReq.res = _self.medSpecReq.res.filter((e) => e.trim() != "");
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/addProfile`,
          body: _self.medSpecReq,
        })
        .then((response) => {
          if (response && response.status === 1000) {
            _self.$parent.getUserData();
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Medical specialities updated successfully",
              class: "sa-a-success",
            });
          } else if (response && response.status == "2001") {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Session Expired. Please login again",
              class: "sa-a-danger",
            });
            _self.$localStorage.remove("token");
            _self.$localStorage.remove("userdata");
            _self.$router.push({ path: "/" });
          } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Something went wrong",
              class: "sa-a-danger",
            });
          }
          _self.loader = false;
        })
        .catch((e) => {
          _self.$store.dispatch("SET_ALERTMESSAGE", {
            msg: "Something went wrong",
            class: "sa-a-danger",
          });
          _self.loader = false;
        });
    },
    saveProfile() {
      let _self = this;
      let p = _self.pInfo;
      if (_self.img) {
        p.img = _self.img;
      }
      _self.$parent.updateProfile(p);
    },
  },
  mounted() {
    this.getStaticData();
    this.getDeptList();
    this.setProfileData();
  },
  watch: {
    pflag: {
      immediate: true,
      deep: true,
      handler() {
        let _self = this;
        _self.editBoolean = _self.pflag;
      },
    },
  },
};
</script>
